import { render } from "./ManageActivityListPage.vue?vue&type=template&id=167d9488"
import script from "./ManageActivityListPage.vue?vue&type=script&lang=ts"
export * from "./ManageActivityListPage.vue?vue&type=script&lang=ts"
script.render = render

export default script